import React, { FunctionComponent } from "react";
import { Input, Label } from "@trussle/external-components";
import { CalculatorTooltip } from "../../calculatorTooltip";

export interface IProps {
  calculatedBorrowAmount: string;
  enteredBorrowAmount?: string;
  mortgageTerm?: string;
  mortgageRate: string;
  setEnteredBorrowAmount: (value: string) => void;
  setMortgageTerm: (value: string) => void;
  setMortgageRate: (value: string) => void;
}

export const CostForm: FunctionComponent<IProps> = (props) => {
  const {
    calculatedBorrowAmount,
    enteredBorrowAmount,
    mortgageTerm,
    mortgageRate,
    setEnteredBorrowAmount,
    setMortgageTerm,
    setMortgageRate,
  } = props;
  return (
    <div className="costForm">
      <div className="form-group">
        <Label
          title=""
          tooltip={(
            <CalculatorTooltip body={(
              <>
                <p className="calculator-tooltip-p">
                  This will be the size of the mortgage. You’ll need to pay it
                  back, along with interest.
                </p>
                <p className="calculator-tooltip-p">
                  The borrowing amount doesn’t include your deposit.
                </p>
              </>
            )}
            />

          )}
          className="calculator-label"
          htmlFor="borrowAmount"
        />
        <Input
          name="Borrow amount"
          label="Mortgage amount"
          inputSize="large"
          id="borrowAmount"
          type="text"
          variant="currency"
          value={enteredBorrowAmount || calculatedBorrowAmount}
          onChange={(e) => {
            const {
              target: { value },
            } = e;
            setEnteredBorrowAmount(value);
          }}
          required
          className="calculator-input"
        />
      </div>
      <div className="form-group">
        <Label
          title=""
          tooltip={(
            <CalculatorTooltip body={(
              <>
                <p className="calculator-tooltip-p">
                  The mortgage term is how many years you have left on your
                  mortgage.
                </p>
                <p className="calculator-tooltip-p">
                  Try out different mortgage terms to see how they affect your
                  monthly repayments and total interest paid.
                </p>
              </>
            )}
            />

          )}
          className="calculator-label"
          htmlFor="mortgageTerm"
        />
        <Input
          name="Mortgage Term"
          label="Mortgage term (years)"
          inputSize="large"
          id="mortgageTerm"
          type="number"
          value={mortgageTerm}
          onChange={(e) => setMortgageTerm(e.target.value)}
          required
          className="calculator-input"
        />
      </div>
      <div className="form-group">
        <Label
          title=""
          tooltip={(
            <CalculatorTooltip body={(
              <>
                <p className="calculator-tooltip-p">
                  This is the rate of interest you’ll pay on your mortgage.
                </p>
                <p className="calculator-tooltip-p">
                  Higher interest rates will generally (but not always) increase
                  your monthly payments, depending on the deal.
                </p>
              </>
            )}
            />

          )}
          className="calculator-label"
          htmlFor="mortgageRate"
        />
        <Input
          variant="percentage"
          name="Mortgage Rate"
          label="Mortgage interest rate (%)"
          inputSize="large"
          id="mortgageRate"
          value={mortgageRate}
          onChange={(e) => setMortgageRate(e.target.value)}
          required
          className="calculator-input"
          step="0.25"
          min="0"
          max="20"
        />
      </div>
    </div>
  );
};
